import DashboardPage from "./dashboard-pages/DashboardPage";
import DashboardDocumentsPage from "./dashboard-pages/DashboardDocumentsPage";
import Dashboard2Page from "./dashboard-pages/Dashboard2Page";
import EconomicActivitesPage from "./dashboard-pages/EconomicActivitiesPage";
import RegimeTypesPage from "./dashboard-pages/RegimeTypesPage";
import TaxPayerPage from "./dashboard-pages/TaxPayerPage";
import {
  TaxPayerEmailSettingsPage,
  TaxPayerWhatsappSettingsPage,
} from "./dashboard-pages/TaxPayerNotificationSettingsPage";
import StampsPage from "./dashboard-pages/StampPage";
import EstablishmentPage from "./dashboard-pages/EstablishmentPage";
import InvoicesPage from "./dashboard-pages/InvoicesPage";
import InvoicePage from "./dashboard-pages/InvoicePage";
import InvoiceReadPage from "./dashboard-pages/InvoiceReadPage";
import ClientsPage from "./dashboard-pages/ClientsPage";
import CatalogItemsPage from "./dashboard-pages/CatalogItemsPage";
import DispatchPointPage from "./dashboard-pages/DispatchPointPage";
import CreditNotesPage from "./dashboard-pages/CreditNotesPage";
import CreditNotePage from "./dashboard-pages/CreditNotePage";
import DisablementPage from "./dashboard-pages/DisablementPage";
import DebitNotesPage from "./dashboard-pages/DebitNotesPage";
import DebitNotePage from "./dashboard-pages/DebitNotePage";
import RemissionNotesPage from "./dashboard-pages/RemissionNotesPage";
import RemissionNotePage from "./dashboard-pages/RemissionNotePage";
import ReceiptsPage from "./dashboard-pages/ReceiptsPage";
import ReceiptPage from "./dashboard-pages/ReceiptPage";
import AutoInvoicesPage from "./dashboard-pages/AutoInvoicesPage";
import AutoInvoicePage from "./dashboard-pages/AutoInvoicePage";
import {
  ACCOUNTING_ENTRIES_RETRIEVE,
  AUTO_INVOICES_CREATE,
  AUTO_INVOICES_RETRIEVE,
  AUTO_INVOICES_UPDATE,
  CREDIT_NOTES_CREATE,
  CREDIT_NOTES_RETRIEVE,
  CREDIT_NOTES_UPDATE,
  DEBIT_NOTES_CREATE,
  DEBIT_NOTES_RETRIEVE,
  DEBIT_NOTES_UPDATE,
  DISABLEMENTS_RETRIEVE,
  INVOICES_CREATE,
  INVOICES_RETRIEVE,
  INVOICES_UPDATE,
  RECEIPTS_CREATE,
  RECEIPTS_RETRIEVE,
  RECEIPTS_UPDATE,
  RECEIVED_DOCUMENTS_RETRIEVE,
  RECEIVED_DOCUMENTS_CREATE,
  RECEIVED_DOCUMENTS_UPDATE,
  REMISSION_NOTES_CREATE,
  REMISSION_NOTES_RETRIEVE,
  REMISSION_NOTES_UPDATE,
  SUPPLIERS_RETRIEVE,
  TAX_PAYER_SETTINGS_UPDATE,
  CONNECTIVITY_MANAGE,
  USERS_RETRIEVE,
  IVA_RETRIEVE,
} from "./auth/permissions";
import ReceivedInvoicesPage from "./dashboard-pages/ReceivedInvoicesPage";
import ReceivedInvoicePage from "./dashboard-pages/ReceivedInvoicePage";
import ReceivedInvoiceReadPage from "./dashboard-pages/ReceivedInvoiceReadPage";
import ReceivedDocumentsPage from "./dashboard-pages/ReceivedDocumentsPage";
import ReceivedDocumentPage from "./dashboard-pages/ReceivedDocumentPage";
import ReceivedDocumentReadPage from "./dashboard-pages/ReceivedDocumentReadPage";
import UserPage from "./dashboard-pages/UserPage";
import SuppliersPage from "./dashboard-pages/SuppliersPage";
import AccountingReportPage from "./dashboard-pages/AccountingReportPage";
import AccountingReportHistoryPage from "./dashboard-pages/AccountingReportHistoryPage";
import AccountingAccountPage from "./dashboard-pages/AccountingAccountPage";
import AccountingEntriesGroupPage from "./dashboard-pages/AccountingEntriesGroupPage";
import TaxPayerApiKeysPage from "./dashboard-pages/TaxPayerApiKeysPage";
import WebhookEndpointsPage from "./dashboard-pages/WebhookEndpointsPage";
import TaxPayerAssetsPage from "./dashboard-pages/TaxPayerAssetsPage";
import PublicPortalConfigPage from "./dashboard-pages/PublicPortalConfigPage";
import AiSettingsPage from "./dashboard-pages/AiSettingsPage";
import AiConnectionsPage from "./dashboard-pages/AiConnectionsPage";
import IvaPage from "./dashboard-pages/IvaPage";
import SifenIncidentsPage from "./dashboard-pages/SifenIncidentsPage";
import { SIFEN_INCIDENT_VIEW_PERMISSIONS } from "./models/sifen-incident";
import { SHOW_SIFEN_INCIDENTS } from "./config/features";

interface Route {
  path: string;
  exact?: boolean | undefined;
  name: string;
  component?: any;
  permissionName?: string | string[];
}

interface RouteMap {
  [index: string]: Route;
}

const routes: RouteMap = {
  ...(SHOW_SIFEN_INCIDENTS ? {
    sifenIncidents: {
      path: "/sifen_incidents/",
      name: "Incidencias SIFEN",
      exact: true,
      component: SifenIncidentsPage,
      permissionName: SIFEN_INCIDENT_VIEW_PERMISSIONS,
    },
  } : {}),
  dashboard: {
    path: "/dashboard/",
    name: "Inicio",
    exact: true,
    component: DashboardPage,
  },
  dashboardDocuments: {
    path: "/dashboard/documents/:documentType/",
    name: "Documentos del resumen",
    exact: true,
    component: DashboardDocumentsPage,
    permissionName: [
      INVOICES_RETRIEVE,
      CREDIT_NOTES_RETRIEVE,
      DEBIT_NOTES_RETRIEVE,
      REMISSION_NOTES_RETRIEVE,
      AUTO_INVOICES_RETRIEVE,
      RECEIPTS_RETRIEVE,
    ],
  },
  dashboard2: {
    path: "/stats/",
    name: "Datos de Uso",
    exact: true,
    component: Dashboard2Page,
  },
  taxPayer: {
    path: "/tax_payer/",
    name: "Contribuyente",
    exact: true,
    component: TaxPayerPage,
    permissionName: TAX_PAYER_SETTINGS_UPDATE,
  },
  taxPayerEmailSettings: {
    path: "/tax_payer/email_settings/",
    name: "Correo electrónico",
    exact: true,
    component: TaxPayerEmailSettingsPage,
    permissionName: TAX_PAYER_SETTINGS_UPDATE,
  },
  taxPayerWhatsappSettings: {
    path: "/tax_payer/whatsapp_settings/",
    name: "WhatsApp",
    exact: true,
    component: TaxPayerWhatsappSettingsPage,
    permissionName: TAX_PAYER_SETTINGS_UPDATE,
  },
  regimeTypes: {
    path: "/regime_types/",
    name: "Régimenes",
    exact: true,
    component: RegimeTypesPage,
    permissionName: TAX_PAYER_SETTINGS_UPDATE,
  },
  economicActivities: {
    path: "/economic_activities/",
    name: "Actividades Económicas",
    exact: true,
    component: EconomicActivitesPage,
    permissionName: TAX_PAYER_SETTINGS_UPDATE,
  },
  stamps: {
    path: "/stamps/",
    name: "Timbrados",
    exact: true,
    component: StampsPage,
    permissionName: TAX_PAYER_SETTINGS_UPDATE,
  },
  dispatchPoints: {
    path: "/dispatch_points/",
    name: "Puntos de expedición",
    exact: true,
    component: DispatchPointPage,
    permissionName: TAX_PAYER_SETTINGS_UPDATE,
  },
  establishments: {
    path: "/establishments/",
    name: "Establecimientos",
    exact: true,
    component: EstablishmentPage,
    permissionName: TAX_PAYER_SETTINGS_UPDATE,
  },
  clients: {
    path: "/clients/",
    name: "Clientes",
    exact: true,
    component: ClientsPage,
    permissionName: [
      INVOICES_RETRIEVE,
      CREDIT_NOTES_RETRIEVE,
      DEBIT_NOTES_RETRIEVE,
      REMISSION_NOTES_RETRIEVE,
      RECEIPTS_RETRIEVE,
    ],
  },
  catalogItems: {
    path: "/catalog_items/",
    name: "Productos y servicios",
    exact: true,
    component: CatalogItemsPage,
    permissionName: [INVOICES_RETRIEVE, INVOICES_CREATE, INVOICES_UPDATE],
  },
  invoices: {
    path: "/invoices/",
    name: "Facturas",
    exact: true,
    component: InvoicesPage,
    permissionName: INVOICES_RETRIEVE,
  },
  addInvoice: {
    path: "/invoice/",
    name: "Agregar Factura",
    exact: true,
    component: InvoicePage,
    permissionName: [INVOICES_CREATE, INVOICES_UPDATE],
  },
  readInvoice: {
    path: "/invoice/read/",
    name: "Ver Factura",
    exact: true,
    component: InvoiceReadPage,
    permissionName: [INVOICES_RETRIEVE],
  },
  autoInvoices: {
    path: "/auto_invoices/",
    name: "Autofacturas",
    exact: true,
    component: AutoInvoicesPage,
    permissionName: AUTO_INVOICES_RETRIEVE,
  },
  addAutoInvoice: {
    path: "/auto_invoice/",
    name: "Agregar Autofactura",
    exact: true,
    component: AutoInvoicePage,
    permissionName: [AUTO_INVOICES_CREATE, AUTO_INVOICES_UPDATE],
  },
  creditNotes: {
    path: "/credit_notes/",
    name: "Notas de Crédito",
    exact: true,
    component: CreditNotesPage,
    permissionName: CREDIT_NOTES_RETRIEVE,
  },
  addCreditNote: {
    path: "/credit_note/",
    name: "Agregar Nota de Crédito",
    exact: true,
    component: CreditNotePage,
    permissionName: [CREDIT_NOTES_CREATE, CREDIT_NOTES_UPDATE],
  },
  debitNotes: {
    path: "/debit_notes/",
    name: "Notas de Débito",
    exact: true,
    component: DebitNotesPage,
    permissionName: DEBIT_NOTES_RETRIEVE,
  },
  addDebitNote: {
    path: "/debit_note/",
    name: "Agregar Nota de Débito",
    exact: true,
    component: DebitNotePage,
    permissionName: [DEBIT_NOTES_CREATE, DEBIT_NOTES_UPDATE],
  },
  remissionNotes: {
    path: "/remission_notes/",
    name: "Notas de Remisión",
    exact: true,
    component: RemissionNotesPage,
    permissionName: REMISSION_NOTES_RETRIEVE,
  },
  addRemissionNote: {
    path: "/remission_note/",
    name: "Agregar Nota de Remisión",
    exact: true,
    component: RemissionNotePage,
    permissionName: [REMISSION_NOTES_CREATE, REMISSION_NOTES_UPDATE],
  },
  receipts: {
    path: "/receipts/",
    name: "Recibos",
    exact: true,
    component: ReceiptsPage,
    permissionName: RECEIPTS_RETRIEVE,
  },
  addReceipt: {
    path: "/receipt/",
    name: "Agregar Recibo",
    exact: true,
    component: ReceiptPage,
    permissionName: [RECEIPTS_CREATE, RECEIPTS_UPDATE],
  },
  disablements: {
    path: "/disablements/",
    name: "Inutilizaciones",
    exact: true,
    component: DisablementPage,
    permissionName: DISABLEMENTS_RETRIEVE,
  },
  receivedInvoices: {
    path: "/received-invoices/",
    name: "Facturas Recibidas(compras)",
    exact: true,
    component: ReceivedInvoicesPage,
    permissionName: RECEIVED_DOCUMENTS_RETRIEVE,
  },
  addReceivedInvoice: {
    path: "/received-invoice/",
    name: "Agregar Compra",
    exact: true,
    component: ReceivedInvoicePage,
    permissionName: RECEIVED_DOCUMENTS_RETRIEVE,
  },
  readReceivedInvoice: {
    path: "/received-invoice/read/",
    name: "Ver Compra",
    exact: true,
    component: ReceivedInvoiceReadPage,
    permissionName: [RECEIVED_DOCUMENTS_RETRIEVE],
  },
  receivedDocuments: {
    path: "/received-documents/",
    name: "Documentos Recibidos",
    exact: true,
    component: ReceivedDocumentsPage,
    permissionName: RECEIVED_DOCUMENTS_RETRIEVE,
  },
  addReceivedDocument: {
    path: "/received-document/",
    name: "Agregar Documento Recibido",
    exact: true,
    component: ReceivedDocumentPage,
    permissionName: [RECEIVED_DOCUMENTS_CREATE, RECEIVED_DOCUMENTS_UPDATE],
  },
  readReceivedDocument: {
    path: "/received-document/read/",
    name: "Ver Documento Recibido",
    exact: true,
    component: ReceivedDocumentReadPage,
    permissionName: [RECEIVED_DOCUMENTS_RETRIEVE],
  },
  users: {
    path: "/users/",
    name: "Usuarios",
    exact: true,
    component: UserPage,
    permissionName: USERS_RETRIEVE,
  },
  suppliers: {
    path: "/suppliers/",
    name: "Proveedores",
    exact: true,
    component: SuppliersPage,
    permissionName: [RECEIVED_DOCUMENTS_RETRIEVE, SUPPLIERS_RETRIEVE],
  },
  accountingReports: {
    path: "/accounting_reports/",
    name: "Crear Reportes Contables",
    exact: true,
    component: AccountingReportPage,
    permissionName: [ACCOUNTING_ENTRIES_RETRIEVE],
  },
  accountingReportsHistory: {
    path: "/accounting_reports_history/",
    name: "Historial Reportes Contables",
    exact: true,
    component: AccountingReportHistoryPage,
    permissionName: [ACCOUNTING_ENTRIES_RETRIEVE],
  },
  accountingAccounts: {
    path: "/accounting_accounts/",
    name: "Cuentas Contables",
    exact: true,
    component: AccountingAccountPage,
    permissionName: [ACCOUNTING_ENTRIES_RETRIEVE],
  },
  accountingEntries: {
    path: "/accounting_entries/",
    name: "Asientos Contables",
    exact: true,
    component: AccountingEntriesGroupPage,
    permissionName: [ACCOUNTING_ENTRIES_RETRIEVE],
  },
  iva: {
    path: "/iva/",
    name: "IVA",
    exact: true,
    component: IvaPage,
    permissionName: [IVA_RETRIEVE],
  },
  taxPayerApiKeys: {
    path: "/taxpayer_api_keys/",
    name: "Api Keys",
    exact: true,
    component: TaxPayerApiKeysPage,
    permissionName: CONNECTIVITY_MANAGE,
  },
  webhookEndpoints: {
    path: "/webhook_endpoints/",
    name: "Webhooks",
    exact: true,
    component: WebhookEndpointsPage,
    permissionName: CONNECTIVITY_MANAGE,
  },
  taxPayerAssets: {
    path: "/tax_payer_assets/",
    name: "Activos del Contribuyente",
    exact: true,
    component: TaxPayerAssetsPage,
    permissionName: TAX_PAYER_SETTINGS_UPDATE,
  },
  publicPortal: {
    path: "/public_portal/",
    name: "Portal de Consulta",
    exact: true,
    component: PublicPortalConfigPage,
    permissionName: TAX_PAYER_SETTINGS_UPDATE,
  },
  // No `permissionName`: on a demo company the panel never receives
  // `tax_payer_settings.update`, yet the server lets the demo's own user manage
  // this one screen. The page guards itself with what the server resolved.
  aiSettings: {
    path: "/ai_settings/",
    name: "Inteligencia Artificial",
    exact: true,
    component: AiSettingsPage,
  },
  // No `permissionName`: what this screen lists belongs to the person, not to a
  // company, and somebody whose last company just had AI turned off still needs
  // a way in to cut a live connection.
  aiConnections: {
    path: "/ai_connections/",
    name: "Conexiones de IA",
    exact: true,
    component: AiConnectionsPage,
  },
};

export const getRoutePath = (key: string) => {
  return routes[key].path;
};
export const getRouteName = (key: string) => {
  return routes[key].name;
};

export default routes;
